var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChatError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 511.49 511.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M500.5 511.5h-245c-68.38 0-132.67-26.63-181.02-74.98-99.3-95.29-99.32-266.75 0-362.04 95.29-99.3 266.75-99.32 362.04 0 96.31 92.45 99.72 257.77 7.61 354.09l64.14 64.14c6.9 6.85 1.95 18.81-7.78 18.78zm-245-490c-310.48 12.88-310.3 455.21 0 468h218.44l-52.98-52.98c-4.3-4.3-4.3-11.26 0-15.56C567.83 275.33 462.39 21 255.5 21.5z",
    fill: "#3d3d3d",
    stroke: "#3d3d3d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M290.29 117.3a34.431 34.431 0 00-25.09-10.9h-18.3c-9.48 0-18.62 3.97-25.09 10.9s-9.8 16.33-9.15 25.78l9.15 132.66c1.24 17.92 16.28 31.96 34.24 31.96s33-14.04 34.24-31.96l9.15-132.66c.65-9.46-2.68-18.85-9.15-25.78zm-3.81 24.89l-9.15 132.66c-.77 11.14-10.12 19.87-21.28 19.87s-20.52-8.73-21.28-19.87l-9.15-132.66c-.86-12.42 8.98-22.8 21.28-22.8h18.3c12.45 0 22.13 10.53 21.28 22.8zm-30.43 184.99c-21.48 0-38.96 17.48-38.96 38.96s17.48 38.96 38.96 38.96 38.96-17.48 38.96-38.96-17.48-38.96-38.96-38.96zm0 64.94c-14.32 0-25.98-11.65-25.98-25.98s11.65-25.98 25.98-25.98 25.98 11.65 25.98 25.98-11.65 25.98-25.98 25.98z",
    stroke: "#e5443c",
    fill: "#e5443c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChatError);
export default __webpack_public_path__ + "static/media/icon-chat-error.8e886fd8c9e29c546b62921533bb3cb9.svg";
export { ForwardRef as ReactComponent };